import { CanRedirectToNewScheduleParams } from '../scheduled-types'

export class CanRedirectToNewScheduleMapper {
  static toPersistence(data: CanRedirectToNewScheduleParams) {
    return {
      council: data.council,
      ...(data?.professionalId && { professionalId: data.professionalId }),
      ...(data.specialtyId && { specialtyId: data.specialtyId }),
      ...(data.originUrl && { originUrl: data.originUrl }),
    }
  }
}
